import { EnvironmentConfig } from "./environment.model";
import { shared } from "./environment.shared";

export const environment: Partial<EnvironmentConfig> = {
  ...shared,
  production: true,
  debugMode: false,
  logToConsole: '#{{ENABLE_LOGGING}}#',
  appVersion: require('../../package.json').version,
  appInsights: {
    instrumentationKey: '#{{APPINSIGHTKEY}}#'
  },
  environmentName: '#{{CLIENT_ENVIRONMENT}}#',
  endpoints: {
    ...shared.endpoints,
    baseApi: { url: '#{{BASE_API}}#', version: 'v1' },
    local: { url: 'assets/', version: '' },
    sealingElementsApi: { url: '#{{SEALINGELEMENTS_API}}#', version: '#{{SEALINGELEMENTS_API_VERSION}}#' },
    oRingsApi: { url: '#{{ORINGS_API}}#', version: '#{{ORINGS_API_VERSION}}#' }
  },
  registration: {
    ...shared.registration,
    redirectUrl: '#{{REDIRECT_URI}}#',
    protectedResources: [
      ['#{{BASE_API}}#', ['api://2c52afb9-1362-4bfc-8284-0bced61075bd/ProductSelector.Read']],
      ['#{{SEALINGELEMENTS_API}}#', ['api://768cf90d-a13f-419a-afaf-70f67bcaa9e4/read']],
      ['#{{ORINGS_API}}#', ['api://768cf90d-a13f-419a-afaf-70f67bcaa9e4/read']],
      ['https://graph.microsoft.com/v1.0/me', ['user.read']],
    ]
  },
};
